import React from 'react'
import { Dropdown } from 'react-bootstrap'
import { HorizontalStack, Icon } from '@ztechapps/webui.util'
import { useAllLocalStorage, useAllSessionStorage, useConfirmDialog } from '@ztechapps/common.hook'
import { useUser } from '../../../hooks/useUser'

export const ClearAllLocalSettings = () => {
  const localStorage = useAllLocalStorage()
  const sessionStorage = useAllSessionStorage()
  const { logout } = useUser()

  const confirmed = async () => {
    logout()
    localStorage.clear()
    sessionStorage.clear()
  }

  const { onConfirm } = useConfirmDialog({
    title: 'Clear all local settings',
    text: ' All table settings and filters will be deleted, you will be logged out after this operation. Are you sure you want to clear all local settings?',
    buttons: {
      confirm: {
        text: 'Yes, clear it!',
      },
    },
    confirmed,
  })

  return (
    <Dropdown.Item onClick={onConfirm}>
      <HorizontalStack gap={1} className="text-danger fw-bold">
        <Icon name="trash-can" />
        <span>Clear all local settings...</span>
      </HorizontalStack>
    </Dropdown.Item>
  )
}
